class accounts {
  constructor(accountId, name, description, unit) {
    this.accountId = accountId;
    this.name = name;
    this.description = description;
    this.unit = unit;
  }
  static fromJson({ cuentaId, nombre, descripcion, unidad }) {
    return new accounts(cuentaId, nombre, descripcion, unidad);
  }
}
export default accounts;
